import { render, staticRenderFns } from "./83.vue?vue&type=template&id=530489ae&scoped=true&"
var script = {}
import style0 from "./83.vue?vue&type=style&index=0&id=530489ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530489ae",
  null
  
)

export default component.exports